import { createContext } from 'react';

export interface NavBlockerContext {
    blockers: Set<string>;
    setBlocked: (id: string, isBlocked: boolean) => void;
}

export const NavBlockerContext = createContext<NavBlockerContext>({
    blockers: new Set(),
    setBlocked: () => {}
});
